import {createStore} from '@ngneat/elf';
import {withEntities} from '@ngneat/elf-entities';
import {withRequestsStatus} from '@ngneat/elf-requests';
import {withPagination} from '@ngneat/elf-pagination';

import {ServiceKind} from '@store/settings/serviceKinds/serviceKinds.model';

export const serviceKindsStore = createStore(
  {name: 'service-kinds'},
  withEntities<ServiceKind>(),
  withPagination(),
  withRequestsStatus(),
);